import { ErrorService } from 'src/services';
import { createReducer } from 'typesafe-actions';
import {
  addTaskAsync,
  getTasksAsync,
  setTaskModalType,
  setTasks,
  setSelectedTask,
  updateTaskAsync,
  setRefreshTable,
  deleteTaskAsync,
} from './actions';
import { TaskInfo, TaskModalType } from './types';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */

export const INITIAL_TASK: TaskInfo = {
  name: '',
  status: null,
};

export type ITasksState = Readonly<{
  tasks: Array<TaskInfo>;
  totalTasks: number;
  isLoading: boolean;
  openModalType: TaskModalType;
  selectedTask: TaskInfo;
  isRefreshTable: boolean;
  error?: Error;
}>;

const initialState: ITasksState = {
  tasks: [],
  totalTasks: 0,
  isLoading: false,
  openModalType: null,
  selectedTask: INITIAL_TASK,
  isRefreshTable: false,
};

/* ------------- Selectors ------------- */

export default createReducer(initialState)
  /* ------------- taskAsync ------------- */
  .handleAction(getTasksAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(getTasksAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    tasks: action.payload.tasks as TaskInfo[],
    totalTasks: action.payload.total,
    error: null,
  }))
  .handleAction(getTasksAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- taskUpdateAsync ------------- */
  .handleAction(updateTaskAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(updateTaskAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    isRefreshTable: true,
    openModalType: false,
    selectedTask: INITIAL_TASK,
    error: null,
  }))
  .handleAction(updateTaskAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- taskAddAsync ------------- */

  .handleAction(addTaskAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(addTaskAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    isRefreshTable: true,
    openModalType: false,
    selectedTask: INITIAL_TASK,
    error: null,
  }))
  .handleAction(addTaskAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- deleteTaskAsync ------------- */
  .handleAction(deleteTaskAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(deleteTaskAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    isRefreshTable: true,
    openModalType: false,
    selectedTask: INITIAL_TASK,
    error: null,
  }))
  .handleAction(deleteTaskAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- setTasks ------------- */
  .handleAction(setTasks, (state, action) => ({
    ...state,
    tasks: action.payload,
  }))
  .handleAction(setTaskModalType, (state, action) => ({
    ...state,
    openModalType: action.payload,
  }))
  .handleAction(setSelectedTask, (state, action) => ({
    ...state,
    selectedTask: action.payload,
  }))
  .handleAction(setRefreshTable, (state, action) => ({
    ...state,
    isRefreshTable: action.payload,
  }));
